import { render, staticRenderFns } from "./BasicView.vue?vue&type=template&id=45ef76c4&scoped=true"
import script from "./BasicView.vue?vue&type=script&lang=js"
export * from "./BasicView.vue?vue&type=script&lang=js"
import style0 from "./BasicView.vue?vue&type=style&index=0&id=45ef76c4&prod&lang=less&scoped=true"
import style1 from "./BasicView.vue?vue&type=style&index=1&id=45ef76c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef76c4",
  null
  
)

export default component.exports